var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.orderId !== 0)?_c('span',{staticStyle:{"cursor":"pointer"},on:{"click":_vm.onFavoriteClicked}},[(_vm.isFavorite)?_c('i',{staticClass:"fas fa-star",staticStyle:{"color":"orange","font-size":"16pt"}}):_c('i',{staticClass:"far fa-star",staticStyle:{"color":"black","font-size":"16pt"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }